// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"ColorBox_deleteIcon__1vWgi","title":"ColorBox_title__3dxYI","inputGroup":"ColorBox_inputGroup__1_828","label":"ColorBox_label__1kJP6"};